import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import {
    AdjustmentsHorizontalIcon,
    Bars3CenterLeftIcon,
    MagnifyingGlassIcon,
    PlusIcon,
} from "@heroicons/react/24/outline";
import { DialogMenu } from "../components/DialogMenu";
import api from "../../../api";
import { ScheduleForm } from "./components/ScheduleForm";
import { Menu, Transition } from "@headlessui/react";
import toast, { Toaster } from "react-hot-toast";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { ScheduleTable } from "./components/ScheduleTable";

export function AgendaPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [schedules, setSchedules] = useState([]);
    const [loading, setLoading] = useState(false);
    const dialogRef = useRef(null);
    const navigate = useNavigate();

    const handleRowClick = (appt) => {
        navigate(`/schedule/agenda/${appt.id}/${appt.doctor.firstName} ${appt.doctor.lastName}`);
    };
    const pages = [
        { name: "Agendamientos", href: "/schedule", current: false },
        { name: "Agenda", href: "/schedule/agenda", current: true },
    ];

    const notify = (message, type = "success") => {
        toast(message, {
            style: {
                background: type === "success" ? "#4caf50" : "#f44336",
                color: "#fff",
                padding: "16px",
                borderRadius: "8px",
            },
            duration: 4000,
        });
    };

    const fetchSchedules = async () => {
        try {
            setLoading(true);
            const data = await api.schedules.getMulti();
            setSchedules(data);
        } catch (error) {
            console.error("Error al obtener los schedules:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSchedules();
    }, []);

    return (
        <div className="bg-gray-100 dark:bg-gray-800 text-black dark:text-white h-screen">
            <Sidebar
                currentScreen={"Agendamiento"}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div className="md:pl-64 flex flex-col h-screen flex-1">
                <LocalHeader
                    dialogRef={dialogRef}
                    setSidebarOpen={setSidebarOpen}
                />
                <main className="p-10 flex flex-col">
                    <Breadcrumbs pages={pages} />
                    <h2 className="text-4xl font-bold mb-10 mt-4 dark:text-gray-200">
                        Configurar agenda
                    </h2>
                    <div className="rounded-lg overflow-hidden shadow-lg border-b border-gray-200 dark:border-gray-700">
                        <ScheduleTable
                            schedules={schedules}
                            loading={loading}
                            onRowClick={handleRowClick}
                        />
                    </div>
                    <DialogMenu dialogRef={dialogRef}>
                        <ScheduleForm
                            dialogRef={dialogRef}
                            onSave={fetchSchedules}
                            notify={notify}
                        />
                    </DialogMenu>
                </main>
            </div>
            <Toaster />
        </div>
    );
}

const LocalHeader = ({ dialogRef, setSidebarOpen }) => {
    return (
        <div className="sticky top-0 z-10 flex h-16 bg-white dark:bg-gray-900 text-black dark:text-white shadow items-center px-5 md:px-10 gap-1 py-5">
            <div className="flex gap-3 flex-1">
                <button
                    onClick={() => setSidebarOpen(true)}
                    className="h-11 w-11 border rounded-lg border-gray-200 dark:border-gray-700 flex justify-center items-center"
                >
                    <Bars3CenterLeftIcon className="h-6 w-6" />
                </button>
                <div className=" flex items-center text-gray-700 bg-gray-100 border border-gray-300 rounded-lg px-2 w-full input-base">
                    <label htmlFor="search">
                        <MagnifyingGlassIcon className="h-6 w-6" />
                    </label>
                    <input
                        type="search"
                        name="search"
                        id="search"
                        className="border-none w-full focus:outline-none focus:ring-0 focus:border-transparent bg-transparent "
                        placeholder="Buscar"
                    />
                </div>
            </div>
            <div className="hidden md:flex justify-end gap-3 flex-1">
                <div className="flex gap-2">
                    <button
                        className="px-3 py-2 rounded-lg flex justify-center items-center gap-2 text-white bg-[#465FFF]"
                        onClick={() => dialogRef.current?.showModal()}
                    >
                        <PlusIcon className="h-6 w-6" />{" "}
                        <span>Nuevo Horario</span>
                    </button>
                </div>
            </div>
            <div className="md:hidden flex justify-end">
                <Menu as="div" className="relative inline-block text-left">
                    <Menu.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700">
                        <AdjustmentsHorizontalIcon className="h-6 w-6" />
                    </Menu.Button>

                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none p-4 flex flex-col gap-3">
                            <button
                                className="px-3 py-2 rounded-lg flex justify-center items-center gap-2 text-white bg-[#465FFF] w-full"
                                onClick={() => dialogRef.current?.showModal()}
                            >
                                <PlusIcon className="h-6 w-6" />
                                <span>Nuevo Horario</span>
                            </button>
                        </Menu.Items>
                    </Transition>
                </Menu>
            </div>
        </div>
    );
};